/* ============================================================
   CPFS — recipes index client-side tag filter
   ------------------------------------------------------------
   Progressive enhancement for the recipes library
   (sections/cpfs-recipes-index.liquid). The category chips
   (.v3-anchor) are real <a href=".../tagged/<handle>"> links:
   without JS they navigate to Shopify's server-filtered tag page.
   With JS, on the full-library page (every recipe rendered), a chip
   click filters the already-rendered cards in place — no reload,
   no scroll jump — and syncs a shareable URL via history.pushState.

   Null-guarded, idempotent, re-runnable on shopify:section:load,
   matching assets/cpfs.js. Reduced motion / no JS: the page renders
   fully and the chips keep working as links.
   ============================================================ */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-recipe-filter-root]';
  var BOUND_ATTR = 'data-recipe-filter-bound';
  var popstateBound = false;

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    }
  }

  /* Tag slug from a URL path: '' for the base blog url ("All recipes"),
     otherwise the handle after /tagged/. */
  function tagFromPath(pathname) {
    var match = /\/tagged\/([^/?#]+)/.exec(pathname || '');
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  /* The tag a chip targets, derived from its href. */
  function chipTag(chip) {
    var href = chip.getAttribute('href') || '';
    var path = href;
    try {
      path = new URL(href, window.location.origin).pathname;
    } catch (e) {
      /* keep the raw href if URL parsing is unavailable */
    }
    return tagFromPath(path);
  }

  /* Only the full-library page holds every recipe in the DOM. */
  function isFullLibrary(root) {
    return root.getAttribute('data-recipe-filter-root') === 'all';
  }

  /* Show cards whose data-tags contains `tag` ('' shows all) and sync the
     active chip. forceReveal lifts newly shown cards out of the scroll-reveal
     opacity:0 state (.cpfs-motion [data-reveal]) so they are actually visible. */
  function applyTag(root, tag, forceReveal) {
    root.querySelectorAll('.v3-anchor').forEach(function (chip) {
      chip.classList.toggle('is-active', chipTag(chip) === tag);
    });
    root.querySelectorAll('.v3-recipe-card').forEach(function (card) {
      var tags = (card.getAttribute('data-tags') || '').split(',');
      var show = tag === '' || tags.indexOf(tag) !== -1;
      card.classList.toggle('is-filtered-out', !show);
      if (show && forceReveal && !card.classList.contains('is-revealed')) {
        card.classList.add('is-revealed');
      }
    });
  }

  function onPopstate() {
    var tag = tagFromPath(window.location.pathname);
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (isFullLibrary(root)) applyTag(root, tag, true);
    });
  }

  function initFilterRoots() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.getAttribute(BOUND_ATTR)) return;

      var chipRow = root.querySelector('.v3-anchors');
      if (!chipRow || !root.querySelector('.v3-recipe-card')) return;

      root.setAttribute(BOUND_ATTR, '1');

      // A direct visit to /tagged/<handle> is server-filtered to that tag, so
      // only some cards exist in the DOM. Leave those chips as native links —
      // the full-library page is where client-side filtering runs.
      if (!isFullLibrary(root)) return;

      chipRow.addEventListener('click', function (e) {
        // Respect new-tab / modified clicks: let the browser navigate.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
        var chip = e.target.closest ? e.target.closest('.v3-anchor') : null;
        if (!chip || !chipRow.contains(chip)) return;
        e.preventDefault();
        var tag = chipTag(chip);
        applyTag(root, tag, true);
        var href = chip.getAttribute('href');
        if (href && window.history && history.pushState) {
          history.pushState({ recipeTag: tag }, '', href);
        }
      });

      // Initialise from the current URL (base page => '' => show all). No forced
      // reveal on load, so the grid keeps its natural scroll-in animation.
      applyTag(root, tagFromPath(window.location.pathname), false);
    });

    if (!popstateBound) {
      popstateBound = true;
      window.addEventListener('popstate', onPopstate);
    }
  }

  ready(initFilterRoots);

  /* Theme editor: re-init idempotently when the section re-renders. */
  document.addEventListener('shopify:section:load', initFilterRoots);
})();
